<template>
  <div :class="[$style.orderAsideStep,
                {[$style.checked] : true },
                {[$style.active] : isCurrentCategory }]">
    <div :class="$style.selectedTitle">
      <h6 :class="titleStyle">{{ currentCategory.name }}</h6>
      <span v-if="itemsCounter && categoryKey !== $options.burgerWrapCategoryId"
            :class="$style.selectedQuantity">
        {{ itemsCounter }}</span>
    </div>

    <div v-if="!isBundleCategory && itemSelectedInCategory(categoryKey)">
      <span v-for="(item, index) in getSelectedItems(categoryKey)"
            :key="item.key"
            :class="$style.orderAsideProducts">
        <span v-if="item.quantity > 1">
          {{ item.quantity }}
        </span>
        {{ items[item.key].name }}
        <span v-if="item.modifier">
          {{ modifierByKey(item.modifier).name }}
        </span>
        <span v-if="index !== getSelectedItems(categoryKey).length - 1">,
        </span>
      </span>
    </div>

    <div v-else-if="isBundleCategory && bundleSelectedProductsList.length">
      <span v-for="(product, index) in bundleSelectedProductsList"
            :key="index">
        <span v-if="index > 0"> + </span>
        {{ product.name }}
      </span>
      <span v-if="bundleTotalPrice">
        ({{ bundleTotalPrice | currency }})
      </span>
    </div>

    <div v-else>
      <span :class="$style.emptyCategory">&#8212;</span>
    </div>

  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Getter } from 'vuex-class';
import { CATEGORY_ID } from '@/config/constants';

/**
 *
 */
@Component({
  name:  'ConfiguratorSelectedOptionsGroup',
  props: {
    categoryKey:          {},
    configuratorCategory: {},
  },
  burgerWrapCategoryId: CATEGORY_ID.BURGER_STYLE,
})
export default class ConfiguratorSelectedOptionsGroup extends Vue {
  @Getter categoryByKey;
  @Getter modifierByKey;
  @Getter items;
  @Getter orderItem;
  @Getter bundleProducts;
  @Getter calculateBundlePriceForProductTemplate;

  /**
   * Check the selected element in current category.
   */
  @Getter itemSelectedInCategory;

  get itemsCounter() {
    const items = this.orderItem[this.categoryKey];

    if (!items) {
      return null;
    }

    if (Object.values(items).length === 0) {
      return 0;
    }

    return Object.values(items).reduce((counter, item) => (
      { quantity: counter.quantity + item.quantity }
    )).quantity;
  }

  get currentCategory() {
    return this.categoryByKey(this.categoryKey);
  }

  /* Return class name for category title */
  get titleStyle() {
    if (this.isCurrentCategory) {
      return this.$style.current;
    } else if (this.itemSelectedInCategory(this.categoryKey)) {
      return this.$style.chosen;
    }

    return this.$style.default;
  }

  /* Return true is the category of the item is current category */
  get isCurrentCategory() {
    const currentCategory =
      this.configuratorCategory === this.currentCategory.orderIndex;

    const bundleSubCategory =
      (this.configuratorCategory >= this.currentCategory.orderIndex)
      && this.isBundleCategory;

    return currentCategory || bundleSubCategory;
  }

  get isBundleCategory() {
    return !this.currentCategory.items.length
      && !!this.currentCategory.subProductId;
  }

  get bundleSelectedProductsList() {
    const productsList = [];

    this.bundleProducts.forEach((product) => {
      productsList.push(this.items[product.productKey]);
    });

    return productsList;
  }

  get bundleTotalPrice() {
    return this.calculateBundlePriceForProductTemplate(this.orderItem);
  }

  /* Return array of selected items of the category */
  getSelectedItems(category) {
    const items = this.orderItem[category];

    if (!items) {
      return null;
    }

    return Object.entries(items)
      .filter(([key]) => key !== 'radio')
      .map(([ key, product ]) => Object.assign({ key }, product));
  }
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";

.orderAsideStep {
  border-top: 1px solid $black-transparent;
  padding: 14px 24px;
  opacity: 0.5;

  .orderAsideProducts {
    font-family: 'Gotham', sans-serif;
    font-size: 13px;
    font-weight: 300;
    color: $black;
    letter-spacing: -0.18px;
    line-height: 20px;
    margin-bottom: 0;
  }

  &.checked {
    opacity: 1;
  }
}

.selectedTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;

  .selectedQuantity {
    width: 25px;
    height: 18px;
    border-radius: 9.25px;
    background-color: $title-black;
    color: $white;
    font-family: 'Gotham', sans-serif;
    font-size: 11px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
  }
}

.orderAsideStep.active {
  opacity: 1;
}

.orderAsideStep.active h6 {
  color: $green-color;
}

.selectedTitle h6{
  text-transform: capitalize;
  color: $black-semi-transparent;
  &.current {
    color: $green-color;
  }
  &.chosen {
    color: $black;
  }
}

.emptyCategory {
  font-family: 'Gotham', sans-serif;
  font-size: 13px;
  font-weight: 300;
  color: $black-semi-transparent;
}


@media screen and (max-width: $kiosk-breakpoint-max) {
  .orderAsideStep {
    border-top: none;
    padding: 19px 22px 83px 34px;
  }

  .orderAsideStep .orderAsideProducts {
    font-size: 22px;
    line-height: 26px;
  }
  .selectedTitle {
    h6 {
      font-size: 26px;
      line-height: 33px;
    }

    .selectedQuantity {
      display: inline;
    }
  }
}

@media screen and (max-width: 1020px) {
  .orderAsideStep {
    border-top: 1px solid $black-transparent;
    padding: 14px 24px;
  }

  .orderAsideStep .orderAsideProducts {
    font-size: 13px;
    line-height: 20px;
  }
  .selectedTitle {
    h6 {
      font-size: 15px;
      line-height: 20px;
    }

    .selectedQuantity {
      display: none;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/apps/configurator/components/ConfiguratorSelectedOptionsGroup.vue